module.exports = __webpack_public_path__ + "c959595e174ad7456c5c0b29e05c0e5b.MP3";